import { render, staticRenderFns } from "./AdminNavbar.vue?vue&type=template&id=b3f27202&scoped=true&"
import script from "./AdminNavbar.vue?vue&type=script&lang=js&"
export * from "./AdminNavbar.vue?vue&type=script&lang=js&"
import style0 from "./AdminNavbar.vue?vue&type=style&index=0&id=b3f27202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f27202",
  null
  
)

export default component.exports